/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";
import {Observable} from 'rxjs';
import {
    ChangePasswordReq,
    ForgotPasswordConfirmReq,
    ForgotPasswordReq,
    LoginRes,
    UserDetailsRes,
    UserUpdateReq
} from '../../../../contracts/v0/cp';
import {BaseCollectionModel, FileContainerReq, SearchModel} from '@yasc/yasc-material-components';
import {ApiV0CrmWorkflow} from '../crm/api.v0.crm.workflow';
import {ApiV0AccountIntegrations} from './integrations/api.v0.crm.integrations';

export class ApiV0Accounts {
    segment = '/Account';

    public readonly integrations: ApiV0AccountIntegrations;

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
        this.integrations = new ApiV0AccountIntegrations(this, rest);
    }

    search(searchModel:SearchModel = new SearchModel({})): Observable<BaseCollectionModel<UserDetailsRes>> {
        return this.rest.post<SearchModel,BaseCollectionModel<UserDetailsRes>>(`${this.segment}/search`, UserDetailsRes, searchModel);
    }

    details(id?: string | null): Observable<UserDetailsRes> {
        if (id == undefined) {
            return this.rest.get<UserDetailsRes>(`${this.segment}/`, UserDetailsRes);
        }
        return this.rest.get<UserDetailsRes>(`${this.segment}/${id}`, UserDetailsRes);
    }

    updateProfileImage(id: string, image: FileContainerReq): Observable<UserDetailsRes> {
        return this.rest.patch<FileContainerReq, UserDetailsRes>(
            `${this.segment}/${id}/profileImage`,
            UserDetailsRes,
            image
        );
    }

    confirmEmail(userId: string, token: string) {
        return this.rest.get<LoginRes>(
            `${this.segment}/ConfirmMail`,
            LoginRes,
            {
                params: {
                    userId: userId,
                    token: token
                }
            }
        );
    }

    changePassword(changePasswordReq: ChangePasswordReq) {
        return this.rest.post<ChangePasswordReq, LoginRes>(
            `${this.segment}/changePassword`,
            LoginRes,
            changePasswordReq
        );
    }

    forgotPassword(model: ForgotPasswordReq) {
        return this.rest.post<ForgotPasswordReq, ForgotPasswordReq>(
            `${this.segment}/forgotPassword`,
            ForgotPasswordReq,
            model
        );
    }

    forgotPasswordConfirmation(model: ForgotPasswordConfirmReq) {
        return this.rest.post<ForgotPasswordConfirmReq, ForgotPasswordConfirmReq>(
            `${this.segment}/forgotPasswordConfirm`,
            ForgotPasswordConfirmReq,
            model
        );
    }

    add(account: UserDetailsRes) {
        return this.rest.post<UserDetailsRes, UserDetailsRes>(
            `${this.segment}/`,
            UserDetailsRes,
            account
        );
    }


    update(account: UserUpdateReq) {
        return this.rest.patch<UserUpdateReq, UserDetailsRes>(
            `${this.segment}/${account.id}`,
            UserDetailsRes,
            account
        )
    }

    delete(account: UserDetailsRes) {
        return this.rest.delete<UserDetailsRes>(
            `${this.segment}/${account.id}`,
        );
    }


}
